import React, { Component } from 'react';
import { ErrorMessage, getIn } from 'formik';
import DatePicker from 'react-datepicker';
import * as moment from 'moment';
import { requiredValidation } from './fieldValidateUtil';
import { FieldTypes, timeSlotPicker } from 'drapcode-constant';
const { time_picker } = FieldTypes;
class DateTimeField extends Component {
  validate = (value) => {
    if (this.props.isConstructorForm) {
      return;
    }
    return requiredValidation(value, this.props.field);
  };

  handleChange = (date) => {
    const { field } = this.props;
    let isShowDateOnly =
      field.extraFieldSetting &&
      ['date', 'date-segregated'].includes(field.extraFieldSetting.dateDisplayType);
    if (timeSlotPicker.includes(field.type)) {
      isShowDateOnly = false;
    }
    const isTimepicker = field.type === time_picker.id;
    if (isShowDateOnly) {
      const seletedDate = new Date(date);
      this.props.setFieldValue(
        this.props.field.fieldName,
        moment(seletedDate).format('YYYY-MM-DD'),
      );
    } else {
      if (isTimepicker) {
        date = date ? moment(date).format('HH:mm') : '';
      } else {
        date = date ? moment(date).format('YYYY-MM-DDTHH:mm:ss') : '';
      }
      console.log('🚀 ~ file: handleChange DateTimeField.js:64 ~ DateTimeField ~ date:', date);
      this.props.setFieldValue(this.props.field.fieldName, date);
    }
  };

  render() {
    const { field, setFieldValue, values, isConstructorForm } = this.props;
    const dateFieldValue = getIn(values, field.fieldName);
    let isShowDateOnly =
      field.extraFieldSetting &&
      ['date', 'date-segregated'].includes(field.extraFieldSetting.dateDisplayType);
    let isShow24Hours =
      field.extraFieldSetting && field.extraFieldSetting.dateDisplayType === '24_HOURS';
    if (timeSlotPicker.includes(field.type)) {
      isShowDateOnly = false;
    }
    const isTimepicker = field.type === time_picker.id;

    return (
      <>
        <DatePicker
          validate={this.validate}
          selected={
            dateFieldValue
              ? isTimepicker
                ? isShow24Hours
                  ? moment(dateFieldValue, 'HH:mm').toDate()
                  : moment(dateFieldValue, 'h:mm a').toDate()
                : moment(dateFieldValue).toDate()
              : dateFieldValue
          }
          name={field.fieldName}
          showTimeSelect={!isShowDateOnly}
          showTimeSelectOnly={!isShowDateOnly && isTimepicker}
          timeFormat={isTimepicker ? (isShow24Hours ? 'HH:mm' : 'h:mm a') : 'h:mm a'}
          timeIntervals={15}
          timeCaption="Time"
          dateFormat={
            isShowDateOnly
              ? 'MMMM d, yyyy'
              : isTimepicker
              ? isShow24Hours
                ? 'HH:mm'
                : 'h:mm a'
              : 'MMMM d, yyyy h:mm aa'
          }
          className="form-control"
          onChange={this.handleChange}
          placeholderText={field.fieldTitle['en']}
          title={field.fieldTitle['en']}
        />
        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  }
}

export default DateTimeField;
